import $ from 'jquery';
import moment from 'moment';

$(() => {
    $('input[name="caseBean.startDate"]').on('change', event => {
        const weekday = moment($(event.target).val()).format('dddd');
        $('#mainForm_caseBean_recurrenceWeekfirst_label').html(`Første ${weekday} i hver måned`);
        $('#mainForm_caseBean_recurrenceWeeklast_label').html(`Sidste ${weekday} i hver måned`);
    });
});